export const name = 'user';
